import { render, staticRenderFns } from "./CommonCustomDiagramCardViewer.vue?vue&type=template&id=d2c23764&scoped=true&"
import script from "./CommonCustomDiagramCardViewer.vue?vue&type=script&lang=ts&"
export * from "./CommonCustomDiagramCardViewer.vue?vue&type=script&lang=ts&"
import style0 from "./CommonCustomDiagramCardViewer.vue?vue&type=style&index=0&id=d2c23764&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2c23764",
  null
  
)

export default component.exports